import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";
import { baseUrl } from "../../api/baseUrl";

const API_BASE_URL = `${baseUrl}/api/v1/provider/`;

// Enhanced base query with network error handling
const brandBaseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: (headers, { endpoint }) => {
    const token = Cookies.get("token");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    // For FormData requests, don't set Content-Type header
    if (endpoint === "updateLoggedInBrand") {
      headers.delete("content-type");
    }
    return headers;
  },
});

const brandBaseQueryWithErrorHandling = async (args, api, extraOptions) => {
  console.log("Brand API - Making request to:", args);
  console.log("Brand API - Base URL:", API_BASE_URL);

  const result = await brandBaseQuery(args, api, extraOptions);

  console.log("Brand API - Response:", result);

  // Check for network connectivity errors
  if (result.error) {
    const { status, error } = result.error;
    console.log("Brand API - Error detected:", { status, error });

    if (
      status === "FETCH_ERROR" ||
      status === "TIMEOUT_ERROR" ||
      error === "Failed to fetch" ||
      error === "NetworkError" ||
      !navigator.onLine
    ) {
      console.log("Brand API network error detected:", result.error);

      // Trigger the NoInternetConnection component
      window.dispatchEvent(
        new CustomEvent("network-error", {
          detail: {
            error: result.error,
            source: "loggedInBrandApi",
            timestamp: Date.now(),
          },
        })
      );
    }
  }

  return result;
};

export const loggedInBrandApi = createApi({
  reducerPath: "loggedInBrandApi",
  baseQuery: brandBaseQueryWithErrorHandling,
  tagTypes: ["LoggedInBrand"],
  endpoints: (builder) => ({
    getLoggedInBrand: builder.query({
      query: () => "brand",
      providesTags: ["LoggedInBrand"],
    }),
    updateLoggedInBrand: builder.mutation({
      query: (formData) => ({
        url: "brand/update",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["LoggedInBrand"],
    }),
  }),
});

export const { useGetLoggedInBrandQuery, useUpdateLoggedInBrandMutation } =
  loggedInBrandApi;
